import {
  type InjectionKey, inject, type Plugin,
} from 'vue';

export interface UppyConfig {
  endpoint: string;
  cookiesRule?: 'same-origin' | 'include' | 'omit';
  getAuthHeaders?: () => Record<string, string>;
}

export const UPPY_CONFIG_INJECTION_KEY = Symbol('UPPY_CONFIG') as InjectionKey<UppyConfig>;

export const createUppyPlugin = (config: UppyConfig) => {
  return {
    install(app) {
      app.provide(UPPY_CONFIG_INJECTION_KEY, config);
    },
  } satisfies Plugin;
};

export const useUppyConfig = (): UppyConfig => {
  const config = inject(UPPY_CONFIG_INJECTION_KEY);
  if (!config) {
    throw new Error('Uppy config was not provided. Make sure to install the Uppy plugin.');
  }

  return config;
};
